import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
import Select from "react-select";
import { Context } from "../../../utils/context";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, getDimension } = useContext(Context);

  const [blogCategory, setBlogCategory] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
    control,
  } = useForm();

  const imageFile = watch("image");
  const logoFile = watch("logo");

  console.log(errors);
  const onSubmit = async (data) => {
    try {
      console.log("Form data:", data);
      const fromData = new FormData();
      fromData.append("course_type_id", data?.course_type_id?.value);
      fromData.append("name", data?.name);
      fromData.append("url", data?.url);
      fromData.append("years", data?.years);
      // fromData.append("sub_name", data?.sub_name);
      fromData.append("description", data?.description);
      fromData.append("meta_description", data?.meta_description);
      fromData.append("meta_tag", data?.meta_tag);
      fromData.append("image", data?.image[0]);
      fromData.append("alt_tag", data?.alt_tag || "");

      // fromData.append("logo", data?.logo[0]);

      const response = await postData(`/masters/course`, fromData);
      console.log("Form response :- ", response);

      if (response?.success) {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllBlogCategory = async () => {
    const response = await getData("/allcoursetype");

    if (response?.success) {
      setBlogCategory(await Select2Data(response?.data, "course_type_id"));
    }
  };

  useEffect(() => {
    GetAllBlogCategory();
  }, []);

  return (
    <>
      <Modal
        onHide={props.handleClose}
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Course
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={handleSubmit(onSubmit)}
            role="form"
            className="countryclass"
          >
            <Row>
              {/* Left side: Title and Image Upload */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Course Type</Form.Label>

                    <Controller
                      name="course_type_id"
                      {...register("course_type_id", {
                        required: "Course Type is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <div style={{ width: "300px" }}>
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,

                                borderColor: errors.course_type_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={blogCategory}
                          />
                        </div>
                      )}
                    />

                    {errors.course_type_id && (
                      <span className="text-danger">
                        {errors.course_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Name</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          type="text"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          placeholder="Title"
                        />
                      </Form.Group>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">URL</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.url,
                          })}
                          type="text"
                          {...register("url", {
                            required: "URL is required",
                          })}
                          placeholder="URL"
                        />
                      </Form.Group>
                      {errors.url && (
                        <span className="text-danger">
                          {errors.url.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Sub Heading</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.sub_name,
                          })}
                          type="text"
                          {...register("sub_name", {
                            required: "sub_name is required",
                          })}
                          placeholder="sub name"
                        />
                      </Form.Group>
                      {errors.sub_name && (
                        <span className="text-danger">
                          {errors.sub_name.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div> */}

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Years</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.years,
                          })}
                          type="number"
                          {...register("years", {
                            required: "Years is required",
                          })}
                          placeholder="Years"
                        />
                      </Form.Group>
                      {errors.years && (
                        <span className="text-danger">
                          {errors.years.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>

                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">
                    Short Description
                  </Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.description,
                          })}
                          type="text"
                          {...register("description", {
                            required: "Description is required",
                          })}
                          placeholder="Description"
                        />
                      </Form.Group>
                      {errors.description && (
                        <span className="text-danger">
                          {errors.description.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>



              {/* Right side: Image Preview */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">
                    Image Alt Tag
                  </Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.alt_tag,
                          })}
                          type="text"
                          {...register("alt_tag", {
                          })}
                          placeholder="Image Alt Tag"
                        />
                      </Form.Group>
                      {errors.alt_tag && (
                        <span className="text-danger">
                          {errors.alt_tag.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Image</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          type="file"
                          {...register("image", {
                            required: "Image is required",
                            // validate: async (value) => {
                            //   if (typeof value !== "string") {
                            //     const fileTypes = ["jpg", "png", "jpeg"];
                            //     const fileType = value[0].name?.split(".")[1];

                            //     if (!fileTypes.includes(fileType)) {
                            //       // return `please upload a valid file format. (${fileTypes})`;
                            //     }

                            //     // const sizes = await getDimension(value[0]);
                            //     // if (
                            //     //   sizes.width !== 230 &&
                            //     //   sizes.height !== 230
                            //     // ) {
                            //     //   // return "Image width and height must be 230px and 230px";
                            //     // }

                            //     const fileSize = Math.round(
                            //       value[0].size / 1024
                            //     );
                            //     if (fileSize > 500) {
                            //       // return "file size must be lower than 500kb";
                            //     }
                            //   }
                            // },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                      </Form.Group>
                      {errors.image && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
                <Col lg={6}>
                  <div className="main-form-section mt-3">
                    <Form.Label className="text-center">Image</Form.Label>
                    <Row className="justify-content-center">
                      <Col sm={9}>
                        {imageFile && imageFile?.length > 0 && (
                          <div className="image-preview-container">
                            <img
                              src={URL.createObjectURL(imageFile[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
                {/* <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Logo</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.logo,
                          })}
                          type="file"
                          {...register("logo", {
                            required: "logo is required",
                            validate: async (value) => {
                              if (typeof value !== "string") {
                                const fileTypes = ["jpg", "png", "jpeg"];
                                const fileType = value[0].name?.split(".")[1];

                                if (!fileTypes.includes(fileType)) {
                                  // return `please upload a valid file format. (${fileTypes})`;
                                }

                                // const sizes = await getDimension(value[0]);
                                // if (
                                //   sizes.width !== 230 &&
                                //   sizes.height !== 230
                                // ) {
                                //   // return "Image width and height must be 230px and 230px";
                                // }

                                const fileSize = Math.round(
                                  value[0].size / 1024
                                );
                                if (fileSize > 500) {
                                  // return "file size must be lower than 500kb";
                                }
                              }
                            },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                      </Form.Group>
                      {errors.logo && (
                        <span className="text-danger">
                          {errors.logo.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div> */}
                {/* <Col lg={6}>
                  <div className="main-form-section mt-3">
                    <Form.Label className="text-center">Logo</Form.Label>
                    <Row className="justify-content-center">
                      <Col sm={9}>
                        {logoFile && logoFile?.length > 0 && (
                          <div className="image-preview-container">
                            <img
                              src={URL.createObjectURL(logoFile[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col> */}
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-5">
                  <Row className="justify-content-center">
                    <Form.Label>Meta Description</Form.Label>

                    <Form.Group>
                      <Controller
                        name="meta_description"
                        control={control}
                        rules={
                          {
                            // required: "description is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }
                        } // Correct the maxLength rule
                        render={({ field: { onChange, onBlur, value } }) => (
                          <JoditEditor
                            value={value}
                            onBlur={() => {
                              onBlur();
                              trigger("meta_description");
                            }}
                            onChange={onChange}
                          />
                        )}
                      />

                      <span className="error-message"></span>
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-5">
                  <Row className="justify-content-center">
                    <Form.Label>Meta Tag</Form.Label>

                    <Form.Group>
                      <Controller
                        name="meta_tag"
                        control={control}
                        rules={
                          {
                            // required: "description is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }
                        } // Correct the maxLength rule
                        render={({ field: { onChange, onBlur, value } }) => (
                          <JoditEditor
                            value={value}
                            onBlur={() => {
                              onBlur();
                              trigger("meta_tag");
                            }}
                            onChange={onChange}
                          />
                        )}
                      />

                      <span className="error-message"></span>
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              {/* Bottom: Description */}
            </Row>

            {/* Buttons */}
            <Row className="justify-content-center mt-5 pb-3">
              <Col sm={6} className="d-flex justify-content-center">
                <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                <SaveButton
                  name={"Save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
